<template>
  <b-form-checkbox
    :checked="isChecked"
    :button="button"
    :button-variant="buttonVariant"
    class="al-checkbox"
    :disabled="disabled"
    :class="getClass()"
    test-id="al-checkbox"
    @input="updateValue"
    @change="$emit('change', isChecked)"
  >
    <div class="check-mark" :class="computedCheckMarkClass">
      <div class="inner-squere" />
    </div>
    <div class="label" :class="{ title: asTitle }">
      <slot />
      <al-icon v-if="tooltip" class="inline" :tooltip="tooltip" icon="help"></al-icon>
    </div>
  </b-form-checkbox>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue';

export default {
  components: {
    BFormCheckbox
  },
  model: {
    prop: 'isChecked',
    event: 'input'
  },
  props: {
    button: {
      type: Boolean,
      default: true
    },
    buttonVariant: {
      type: String,
      default: ''
    },
    isChecked: Boolean,
    disabled: Boolean,
    name: {
      type: String,
      default: ''
    },
    single: {
      type: Boolean,
      default: false
    },
    variation: {
      type: String,
      default: ''
    },
    tooltip: {
      type: String,
      default: null
    },
    asTitle: Boolean
  },
  computed: {
    computedCheckMarkClass() {
      return {
        selected: this.isChecked
      };
    }
  },
  methods: {
    updateValue(checked) {
      this.$emit('input', checked);
    },
    getClass() {
      const round = this.includesAny(this.variation, ['round']);
      const single = this.includesAny(this.variation, ['single']) || this.single;
      return [{ single, round }];
    },
    includesAny(str, subStrings) {
      return subStrings.some((word) => str.includes(word));
    }
  }
};
</script>

<style lang="scss">
.al-checkbox {
  .btn,
  .btn-secondary:not(:disabled):not(.disabled).active,
  .btn-secondary:not(:disabled):not(.disabled):active {
    align-items: flex-start;
    background: color(white, lighten, 1);
    border: 1px solid #d9e3e2;
    box-shadow: none;
    color: black;
    display: inline-flex;
    justify-content: flex-start;
    padding: 20px;

    .check-mark {
      align-items: center;
      background-color: color(white, lighten, 1);
      border: 1px solid color(white, darken, 3);
      border-radius: 4px;
      display: inline-block;
      display: flex;
      flex-shrink: 0;
      height: 20px;
      justify-content: center;
      margin-right: 20px;
      width: 20px;

      > div {
        background: color(white, darken, 3);
        height: 12px;
        width: 12px;
      }

      &.selected {
        > div {
          background-color: color(green);
        }
      }
    }

    p {
      text-align: left;
    }
  }

  .btn {
    height: auto;
  }
}

.al-checkbox.single {
  align-items: center;
  //its necesary the important for replace a bootrap style
  display: inline-flex !important;
  justify-content: flex-start;
  padding: 5px 0;

  .al-icon {
    margin-left: 5px;
  }

  .label {
    display: flex;
    margin-left: 10px;

    .inline {
      margin-left: 10px;
    }
  }

  .btn,
  .btn-secondary:not(:disabled):not(.disabled).active,
  .btn-secondary:not(:disabled):not(.disabled):active {
    align-items: center;
    border: 0;
    margin-right: 10px;
    padding: 0;

    .check-mark {
      margin: 0;
    }
  }
}

.al-checkbox.round {
  .btn,
  .btn-secondary:not(:disabled):not(.disabled).active,
  .btn-secondary:not(:disabled):not(.disabled):active {
    .check-mark,
    .check-mark > div {
      border-radius: 50%;
    }
  }
}
</style>
